"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var tooltip_1 = require("../tooltip");
var ListItem = /** @class */ (function (_super) {
    tslib_1.__extends(ListItem, _super);
    function ListItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onClick = function (e) {
            _this.handleSelect(e);
        };
        _this.item = React.createRef();
        _this.state = { longContent: false };
        return _this;
    }
    ListItem.prototype.componentDidMount = function () {
        var _this = this;
        utils_1.raf(function () {
            if (!_this.item.current) {
                return;
            }
            _this.setState({
                longContent: _this.item.current.offsetWidth < _this.item.current.scrollWidth
            });
        });
    };
    ListItem.prototype.handleSelect = function (clickEvent) {
        var _a = this.props, value = _a.value, label = _a.label, onItemSelect = _a.onItemSelect, disabled = _a.disabled, onClick = _a.onClick, item = _a.item;
        if (disabled) {
            return;
        }
        onItemSelect && onItemSelect(value, label, false, item);
        clickEvent && onClick && onClick(clickEvent);
    };
    ListItem.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, selected = _b.selected, active = _b.active, disabled = _b.disabled, label = _b.label, value = _b.value, onItemSelect = _b.onItemSelect, iconName = _b.iconName, iconSize = _b.iconSize, item = _b.item, children = _b.children, spaceBetween = _b.spaceBetween, others = tslib_1.__rest(_b, ["theme", "className", "selected", "active", "disabled", "label", "value", "onItemSelect", "iconName", "iconSize", "item", "children", "spaceBetween"]);
        var longContent = this.state.longContent;
        var classes = classnames_1.default(theme.item, className, (_a = {},
            _a[theme.selected] = selected,
            _a[theme.active] = active,
            _a[theme.disabled] = disabled,
            _a[theme.truncate] = longContent,
            _a[theme.spacebetween] = spaceBetween,
            _a));
        var content = (React.createElement("div", tslib_1.__assign({ ref: this.item }, others, { className: classes, onClick: this.onClick, "data-value": value, "data-selected": !!selected, "data-active": !!active }),
            !!iconName ? React.createElement(icon_1.default, { className: theme.icon, iconName: iconName, size: iconSize }) : null,
            React.createElement("div", { className: theme.label }, label),
            children,
            selected ? React.createElement(icon_1.default, { className: theme.selectIcon, size: 1, iconName: "icon-v-small" }) : null));
        if (longContent) {
            return (React.createElement(tooltip_1.default, { title: label }, content));
        }
        return content;
    };
    ListItem.defaultProps = {
        selected: false,
        iconSize: 1.6
    };
    return ListItem;
}(React.Component));
exports.default = ListItem;
